export default __webpack_public_path__ + "static/033-9602d532d246450b2c8caed9d19c3a20.png";